export default __webpack_public_path__ + "static/media/SWT1150.34I-40551_-23969_0.beca5ef9.jpg";